import React from 'react';

export default function CrmModal({
  isOpen = true,
  onClose,
  title,
  subtitle,
  icon: IconComponent,
  children,
  footer,
  maxWidth = 920,
}) {
  if (!isOpen) return null;

  return (
    <div className="cm-modal-overlay" onClick={onClose}>
      <div
        className="cm-modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ width: maxWidth, maxWidth: '95vw' }}
      >
        {/* Header Section (Fixed Top) */}
        <div className="cm-modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            {IconComponent && (
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  background: '#f0f4ff',
                  color: '#224eae',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.2rem',
                  flexShrink: 0,
                  border: '1px solid #dbeafe',
                }}
              >
                <IconComponent size={22} />
              </div>
            )}
            <div>
              <h2 style={{ margin: 0, fontSize: '1.3rem', fontWeight: 800, color: '#0f172a' }}>
                {title}
              </h2>
              {subtitle && (
                <div style={{ fontSize: '0.85rem', color: '#64748b', marginTop: 2 }}>
                  {subtitle}
                </div>
              )}
            </div>
          </div>

          <button className="cm-modal-close-btn" onClick={onClose} title="Close Modal">
            ✕
          </button>
        </div>

        {/* Body Section (Scrollable Middle) */}
        <div className="cm-modal-body">{children}</div>

        {/* Footer Section (Fixed Bottom) */}
        {footer && <div className="cm-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
